<template>
    <div>
        <h1>Works</h1>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>

</style>